
  import {createControllersWithDescriptors, initAppForPageWrapper} from '@wix/yoshi-flow-editor/runtime/esm/viewerScript/wrapper.js';
  
  
            
import wrapController0 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller0 from '/home/builduser/work/12acb351b62a96cd/packages/profile-page-bob/src/components/FFList/viewer.controller.ts';
            import * as _controllerExport0 from '/home/builduser/work/12acb351b62a96cd/packages/profile-page-bob/src/components/FFList/model.ts';
            var controllerExport0 = _controllerExport0;
            

            
import wrapController1 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller1 from '/home/builduser/work/12acb351b62a96cd/packages/profile-page-bob/src/components/FFModal/viewer.controller.ts';
            import * as _controllerExport1 from '/home/builduser/work/12acb351b62a96cd/packages/profile-page-bob/src/components/FFModal/model.ts';
            var controllerExport1 = _controllerExport1;
            

            
import wrapController2 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller2 from '/home/builduser/work/12acb351b62a96cd/packages/profile-page-bob/src/components/Menu/viewer.controller.ts';
            import * as _controllerExport2 from '/home/builduser/work/12acb351b62a96cd/packages/profile-page-bob/src/components/Menu/model.ts';
            var controllerExport2 = _controllerExport2;
            

            
import wrapController3 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller3 from '/home/builduser/work/12acb351b62a96cd/packages/profile-page-bob/src/components/SettingsPage/viewer.controller.ts';
            import * as _controllerExport3 from '/home/builduser/work/12acb351b62a96cd/packages/profile-page-bob/src/components/SettingsPage/model.ts';
            var controllerExport3 = _controllerExport3;
            


            
import wrapController5 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller5 from '/home/builduser/work/12acb351b62a96cd/packages/profile-page-bob/src/components/Widget1/viewer.controller.ts';
            import * as _controllerExport5 from '/home/builduser/work/12acb351b62a96cd/packages/profile-page-bob/src/components/Widget1/model.ts';
            var controllerExport5 = _controllerExport5;
            

  
  import * as viewerApp from '/home/builduser/work/12acb351b62a96cd/packages/profile-page-bob/src/viewer.app.ts';
    var importedApp = viewerApp;


  

    import { initState, initBind } from '@wix/yoshi-flow-editor/runtime/esm/velocycleMobx';
    import { observable } from 'mobx';
    var velocycleMobx = { initState, initBind, observable };
    


  

    import { blocksControllerService } from '@wix/yoshi-flow-editor/runtime/esm/blocks/controllerService'
    

  
var createHttpClient = null;

  

  import { initI18n as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


  
const multilingualDisabled = false;

  

    var createExperiments = null;
    var createWidgetExperiments = null;
    


  var sentryConfig = {
      DSN: 'https://1d7d0a2217a04496808b11f7603693e5@sentry-next.wixpress.com/7856',
      id: 'undefined',
      projectName: 'profile-page-bob',
      teamName: 'undefined',
      errorMonitor: true,
    };

  var experimentsConfig = {"centralized":true,"scopes":[]};

  var translationsConfig = {"icuEnabled":true,"defaultTranslationsPath":"/home/builduser/work/12acb351b62a96cd/packages/profile-page-bob/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hr","hu","id","it","ja","ko","lt","lv","ms","nl","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};

  var defaultTranslations = {"app.widget.welcome":"Welcome","app.page.settings.elements.panel.title":"Page Title","app.fflist.demo-member-nickname.1":"Christabelle Dean (Demo)","app.widget.gfpp.change-layout":"Change Layout","app.empty-state.not-found.title":"We can’t find the page you’re looking for","app.settings.elements.panel.member-menu":"Member Menu","app.ffmodal.tab.followers":"Followers","app.ffmodal.empty-state.following-others":"When {memberName} follows someone, you’ll see them here.","app.settings.manage.menu.panel.followers.title":"Followers/Following","app.error-state.page-load.button":"Try Again","app.error-state.page-load.title":"We couldn’t load this page","app.profile-page.horizontal-menu.unified-manager.gfpp":"Manage Member Pages","app.page.title.private":"Account","app.empty-state.not-found.button":"Go to Home","editor.member-menu.label":"Member Menu","app.settings.manage.menu.panel.title":"Manage and Navigate","app.fflist.demo-member-nickname.2":"Tom Grey (Demo)","app.empty-state.not-found.description":"This page doesn’t exist. Go to Home and keep exploring.","app.settings.manage.menu.panel.manage-and-navigate-renaming.cta":"Manage and Navigate","app.widget.gfpp.manage-member-privacy":"Manage member privacy","app.settings.manage.menu.panel.unified-manager.cta":"Add or Remove Tabs","app.ffmodal.header.close":"Close","app.empty-state.user-is-blocked.button":"See Blocked Members","app.ffmodal.empty-state.following-yourself":"When you follow someone, you’ll see them here.","app.fflist.cta.follow.label":"Follow {memberName}","app.settings.defaults.greetingsPretext":"to","app.settings.elements.panel.member-card":"Member Card","app.page.sausage-bar.cta.manage-member-pages.title":"Manage Member Pages","app.settings.tabs.design":"Design","app.settings.layout.preset.full-width":"Full Width","app.settings.manage.menu.panel.item.action.delete-tab":"Delete Tab","app.settings.manage.menu.panel.item.edit-label.validation-message":"Page Title should be 1 character or more with no special characters or emojis.","app.profile-page.expandable-menu.unified-manager.gfpp":"Manage Member Pages","app.page.profile.title":"Profile","app.empty-state.user-is-blocked.title":"You blocked {memberName}","app.settings.manage.menu.panel.item.subtitle.public":"Public","app.fflist.cta.follow":"Follow","app.settings.manage.menu.panel.followers.value":"Public · Not shown in menu","app.fflist.cta.following.label":"Following {memberName}","app.settings.layout.preset.title":"Page Layout","app.settings.tabs.main":"Main","app.settings-page.unified-manager.gfpp":"Manage Member Pages","app.profile-page.unified-manager.gfpp":"Manage Member Pages","app.settings.manage.menu.panel.item.subtitle.private":"Private","app.page.title":"Member Page","app.settings.manage.menu.panel.manage-member-privacy.cta":"Manage Member Privacy","app.settings.manage.menu.panel.add-more-tabs.cta":"Add More Tabs","app.settings-page.horizontal-menu.unified-manager.gfpp":"Manage Member Pages","app.page.sausage-bar.tabs-label":"{tabsCount, plural, one {1 tab} other {{tabsCount,number} tabs}}","app.ffmodal.tab.following":"Following","app.ffmodal.empty-state.followers-others":"When someone follows {memberName}, you’ll see them here.","app.page.settings.elements.panel.member-menu":"Settings Menu","app.settings.layout.preset.subtitle":"Choose a layout:","app.ffmodal.empty-state.followers-yourself":"When people follow you, you’ll see them here.","app.fflist.cta.following":"Following","app.settings.manage.menu.panel.item.action.edit-tab-name":"Edit Tab Name","app.settings.label":"Configure Widget","app.settings.bp.banner.desktop-and-tablet":"Changes apply to desktop and tablet. <1>Learn More</1>","app.page.settings.title":"Account Settings","app.empty-state.user-is-blocked.description":"Member’s content is not available for you to see anymore.","app.settings.layout.preset.cards":"Cards","app.page.title.public":"Profile","app.settings-page.expandable-menu.unified-manager.gfpp":"Manage Member Pages","members-menu.gfpp.manage-and-navigate":"Manage and Navigate"};

  var fedopsConfig = null;

  import { createVisitorBILogger as biLogger } from '/home/builduser/work/12acb351b62a96cd/packages/profile-page-bob/target/generated/bi/createBILogger.ts';

  export const exports = importedApp.exports;

  export const initAppForPage = initAppForPageWrapper({
    initAppForPage: importedApp.initAppForPage,
    sentryConfig: sentryConfig,
    experimentsConfig: experimentsConfig,
    inEditor: false,
    biLogger: biLogger,
    multilingualDisabled,
    projectName: "profile-page-bob",
    biConfig: null,
    appName: "Profile Page BoB",
    appDefinitionId: "b976560c-3122-4351-878f-453f337b7245",
    fedopsConfig: fedopsConfig,
    translationsConfig: translationsConfig,
    defaultTranslations: defaultTranslations,
    shouldUseEssentials: true,
    optionalDeps: {
      initI18n,
      createHttpClient,
      createExperiments,
    },
    localeDistPath: "assets/locales",
  });

  const _createControllers = createControllersWithDescriptors({
    initI18n,
    blocksControllerService,
    createHttpClient,
    createExperiments,
    velocycleMobx,
  }, [{ method: controller0,
          wrap: wrapController0,
          exports: controllerExport0,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":[]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/12acb351b62a96cd/packages/profile-page-bob/src/components/FFList/viewer.controller.ts",
          appName: "Profile Page BoB",
          appDefinitionId: "b976560c-3122-4351-878f-453f337b7245",
          projectName: "profile-page-bob",
          componentName: "FFList",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "b976560c-3122-4351-878f-453f337b7245-zuaoa" }, { method: controller1,
          wrap: wrapController1,
          exports: controllerExport1,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":[]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/12acb351b62a96cd/packages/profile-page-bob/src/components/FFModal/viewer.controller.ts",
          appName: "Profile Page BoB",
          appDefinitionId: "b976560c-3122-4351-878f-453f337b7245",
          projectName: "profile-page-bob",
          componentName: "FFModal",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "b976560c-3122-4351-878f-453f337b7245-xhv4l" }, { method: controller2,
          wrap: wrapController2,
          exports: controllerExport2,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":[]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/12acb351b62a96cd/packages/profile-page-bob/src/components/Menu/viewer.controller.ts",
          appName: "Profile Page BoB",
          appDefinitionId: "b976560c-3122-4351-878f-453f337b7245",
          projectName: "profile-page-bob",
          componentName: "Menu",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "b976560c-3122-4351-878f-453f337b7245-ng58u" }, { method: controller3,
          wrap: wrapController3,
          exports: controllerExport3,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":[]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/12acb351b62a96cd/packages/profile-page-bob/src/components/SettingsPage/viewer.controller.ts",
          appName: "Profile Page BoB",
          appDefinitionId: "b976560c-3122-4351-878f-453f337b7245",
          projectName: "profile-page-bob",
          componentName: "SettingsPage",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "b976560c-3122-4351-878f-453f337b7245-uuc0d" }, { method: null,
          wrap: null,
          exports: null,
          widgetType: "WIDGET_OUT_OF_IFRAME",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":[]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/12acb351b62a96cd/packages/profile-page-bob/src/components/SettingsPageOoi/controller.ts",
          appName: "Profile Page BoB",
          appDefinitionId: "b976560c-3122-4351-878f-453f337b7245",
          projectName: "profile-page-bob",
          componentName: "SettingsPageOoi",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "88aef700-7f48-4e03-85f2-9b6399581d51" }, { method: controller5,
          wrap: wrapController5,
          exports: controllerExport5,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":[]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/12acb351b62a96cd/packages/profile-page-bob/src/components/Widget1/viewer.controller.ts",
          appName: "Profile Page BoB",
          appDefinitionId: "b976560c-3122-4351-878f-453f337b7245",
          projectName: "profile-page-bob",
          componentName: "Widget1",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "b976560c-3122-4351-878f-453f337b7245-mty3l" }],
    false);

    export const createControllers = _createControllers
